window.theme.component('category-select', el => {
	const trigger = el.querySelector('.js-category-select-trigger');
	const overlay = el.querySelector('.js-category-select-overlay');
	const backdrop = el.querySelector('.js-category-select-backdrop');
	const closeButton = el.querySelector('.js-category-select-close');
	const searchInput = el.querySelector('.js-category-select-search');
	const options = el.querySelectorAll('.js-category-select-option');
	const groups = el.querySelectorAll('.js-category-select-group');

	if (!trigger || !overlay) return;

	// Accent-insensitive match: NFD splits "e" into "e" + a combining accent
	// mark, then the regex strips that mark, so searching "eletronicos" still
	// finds "Eletronicos".
	function normalize(text) {
		return text.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
	}

	function filterOptions(query) {
		const term = normalize(query);

		options.forEach(option => {
			const matches = !term || normalize(option.textContent).indexOf(term) !== -1;
			option.classList.toggle('is-hidden', !matches);
		});

		groups.forEach(group => {
			const visibleOptions = group.querySelectorAll('.js-category-select-option:not(.is-hidden)');
			group.classList.toggle('is-hidden', visibleOptions.length === 0);
		});
	}

	function openPanel() {
		overlay.hidden = false;
		overlay.classList.add('is-open');
		trigger.setAttribute('aria-expanded', 'true');
		document.body.classList.add('scroll-lock');

		if (searchInput) {
			searchInput.value = '';
			filterOptions('');
			setTimeout(() => searchInput.focus(), 50);
		}
	}

	function closePanel() {
		overlay.classList.remove('is-open');
		overlay.hidden = true;
		trigger.setAttribute('aria-expanded', 'false');
		document.body.classList.remove('scroll-lock');
	}

	trigger.addEventListener('click', () => {
		if (overlay.classList.contains('is-open')) {
			closePanel();
		} else {
			openPanel();
		}
	});

	if (closeButton) closeButton.addEventListener('click', closePanel);
	if (backdrop) backdrop.addEventListener('click', closePanel);

	document.addEventListener('keydown', event => {
		if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
			closePanel();
		}
	});

	if (searchInput) {
		searchInput.addEventListener('input', () => filterOptions(searchInput.value));
	}
});
